import { createFileRoute } from '@tanstack/react-router'
import ConsultationFluxTab from '@features/stock/components/ConsultationFluxTab'

export const Route = createFileRoute('/_app/stock/consultation/')({
  component: ConsultationFluxTab,
})
